import UserRole from "../../../../../common/types/user-role";
import UserPermissions from "../../../../../common/utils/user/permissions/user-permissions";
import UserPermissionsDefinition from "../../../../../common/utils/user/permissions/user-permissions-definition";

export type OrderActiveListingUserPermissionOption =
  | "hasVisibleOrderAddLink"
  | "hasVisiblePlannerLink"
  | "hasVisibleOrderJoinButton"
  | "hasVisibleToOrderPlanningButton"
  | "hasVisibleOptitoolButton";

export type OrderActiveListingUserPermissionsDefinition =
  UserPermissionsDefinition<OrderActiveListingUserPermissionOption>;

export type OrderActiveListingUserPermissions =
  UserPermissions<OrderActiveListingUserPermissionOption>;

const orderActiveListingUserPermissionDefinition: OrderActiveListingUserPermissionsDefinition =
  {
    hasVisibleOrderAddLink: [
      UserRole.ADMIN,
      UserRole.DISPATCHER,
      UserRole.OPERATOR,
    ],
    hasVisiblePlannerLink: [],
    hasVisibleOrderJoinButton: [UserRole.ADMIN, UserRole.OPERATOR],
    hasVisibleToOrderPlanningButton: [UserRole.ADMIN],
    hasVisibleOptitoolButton: [
      UserRole.ADMIN,
      UserRole.OPERATOR,
      UserRole.DISPATCHER,
    ],
  };

export default orderActiveListingUserPermissionDefinition;
